<mat-card class="card mat-elevation-z4" [ngClass]="showAll ? 'expanded' : 'clipped'">
  <mat-card-content class="card__content">
    <div class="card__border">
      <img [src]="img" [alt]="altText" class="card__img" />
    </div>

    <h3 class="card__name">{{_name}}</h3>
    <span class="card__position">{{position}}</span>
    <h4 class="card__bio" [ngClass]="showAll ? '' : 'clipped'" (click)="showAll = !showAll">{{bio}}</h4>
  </mat-card-content>

  <mat-card-footer class="card__social" [ngClass]="showAll ? '' : 'clipped'">
    <a mat-icon-button *ngIf="twitterLink" target="_blank" [href]="twitterLink">
      <mat-icon svgIcon="twitter"></mat-icon>
    </a>
    <a mat-icon-button *ngIf="linkedinLink" target="_blank" [href]="linkedinLink">
      <mat-icon svgIcon="linkedin"></mat-icon>
    </a>
    <a mat-icon-button *ngIf="websiteLink" target="_blank" [href]="websiteLink">
      <mat-icon>link</mat-icon>
    </a>
  </mat-card-footer>
</mat-card>